<template>
  <div>
    <div style="display: flex;justify-content: space-between">
      <div style="padding-bottom: 30px">
        <el-button type="primary" icon="el-icon-plus" @click="showAddSchoolView">添加学校</el-button>
      </div>
    </div>
    <el-table
        v-loading="loading"
        @selection-change="handleSelectionChange"
        :data="schoolList"
        border
        style="width: 100%">
      <el-table-column
          type="selection"
          width="40">
      </el-table-column>
      <el-table-column
          prop="name"
          label="学校">
      </el-table-column>
      <el-table-column
          prop="email"
          label="邮箱">
      </el-table-column>
      <el-table-column
          prop="date"
          label="创建日期">
      </el-table-column>
      <el-table-column
          label="状态"
          width="150">
        <template slot-scope="scope">
          <el-switch
              v-model="scope.row.enabled"
              @change="enabledChange(scope.row)"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
              active-text="启用"
              inactive-text="禁用">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
          label="操作">
        <template slot-scope="scope">
          <el-button @click="showEditSchoolView(scope.row)">编辑
          </el-button>
          <el-button type="danger" @click="deleteSchool(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top:10px;display: flex;justify-content: space-between">
      <el-button type="danger" size="small"
                 :disabled="this.multipleSelection.length===0"
                 @click="deleteMany">批量删除({{ this.multipleSelection.length }})
      </el-button>
      <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          layout="sizes,prev, pager, next, jumper, ->, total"
          :total="total">
      </el-pagination>
    </div>
    <el-dialog
        title="添加学校"
        :visible.sync="dialogVisible"
        width="400px">
      <div>
        <el-form ref="schoolForm" :model="school" :rules="rules">
          <el-form-item label="学校名" prop="name">
            <el-input style="width: 270px" v-model="school.name"
                      placeholder="请输入学校名"></el-input>
          </el-form-item>
          <el-form-item label="邮  箱" prop="email">
            <el-input style="width: 270px" v-model="school.email"
                      placeholder="请输入邮箱@xxx.xx"></el-input>
          </el-form-item>
          <el-form-item label="状  态" prop="enabled">
            <el-switch
                v-model="school.enabled"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                active-text="启用"
                inactive-text="禁用">
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="addSchool()">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog
        title="修改学校信息"
        :visible.sync="editDialogVisible"
        width="400px">
      <div>
        <el-form ref="schoolEditForm" :rules="editRules" :model="school" >
          <el-form-item label="学校名" prop="name">
            <el-input style="width: 270px" v-model="school.name"
                      placeholder="请输入学校名"></el-input>
          </el-form-item>
          <el-form-item label="邮  箱" prop="email">
            <el-input style="width: 270px" v-model="school.email"
                      placeholder="请输入邮箱@xxx.xx"></el-input>
          </el-form-item>
          <el-form-item label="状  态" prop="enabled">
            <el-switch
                v-model="school.enabled"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                active-text="启用"
                inactive-text="禁用">
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="editDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="changeSchool()">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "SchoolList",
  data() {
    return {
      schoolList: [],
      loading: false,
      total: 0,
      currentPage: 1,
      size: 10,
      multipleSelection: [],
      school: {
        name: '',
        email: '',
        enabled:1
      },
      rules: {
        name: [{
          required: true,
          message: '请输入学校名',
          trigger: blur
        }
        ],
        email: [{
          required: true,
          message: '请输入邮箱域名',
          trigger: blur
        }
        ]
      },
      editRules: {
        name: [{
          required: true,
          message: '请输入学校名',
          trigger: blur
        }
        ],
        email: [{
          required: true,
          message: '请输入邮箱域名',
          trigger: blur
        }
        ]
      },
      dialogVisible: false,
      editDialogVisible: false,
    }
  },
  mounted() {
    this.initSchool()
  },
  methods: {
    initSchool() {
      this.loading = true
      this.getRequest('/school/web/?currentPage=' + this.currentPage + '&size=' + this.size).then(resp => {
        this.loading = false
        if (resp) {
          this.schoolList = resp.data
          this.total = resp.total
        }
      })
    },
    sizeChange(size) {
      this.size = size
      this.organizationAudit()
    },
    currentChange(currentPage) {
      this.currentPage = currentPage
      this.organizationAudit()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    deleteMany() {
      this.$confirm('此操作将永久删除' + this.multipleSelection.length + '条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = '?'
        this.multipleSelection.forEach(item => {
          ids += 'ids=' + item.id + '&'
        })
        this.deleteRequest('/school/web/' + ids).then(resp => {
          if (resp) {
            this.initSchool()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    deleteSchool(school) {
      this.$confirm('此操作将永久删除【' + school.name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRequest('/school/web/' + school.id).then(resp => {
          if (resp) {
            this.initSchool()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    enabledChange(school) {
      this.putRequest('/school/web/', school).then(resp => {
        if (resp) {
          this.initSchool();
        }
      })
    },
    addSchool(){
      this.$refs['schoolForm'].validate(valid => {
        if (valid) {
          this.postRequest('/school/web/addSchool', this.school).then(resp => {
            if (resp) {
              this.dialogVisible = false
              this.initSchool()
            }
          })
        } else {
          this.$message('标*字段不能为空')
        }
      })
    },
    showAddSchoolView () {
     this.school = {
       name:'',
       email:'',
       enabled:1
     }
      this.dialogVisible = true
    },
    showEditSchoolView(school){
      this.school = school
      this.editDialogVisible = true
    },
    changeSchool(){
      this.$refs['schoolEditForm'].validate(valid => {
        if (valid) {
          this.putRequest('/school/web/', this.school).then(resp => {
            if (resp) {
              this.editDialogVisible = false
              this.initSchool()
            }
          })
        } else {
          this.$message('标*字段不能为空')
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
